const whitePotImageSrc = 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/pl_MoneyTree_6IN_po_newcer_white_a94f308d-779f-416c-8342-7e1dd01cec7c.jpg?v=1697004588';
const navyPotImageSrc = 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/pl_MoneyTree_6IN_po_newcer_navy_8370fb04-cded-4459-b045-71f1a111568e.jpg?v=1697004244';
const greyPotImageSrc = 'https://cdn.shopify.com/s/files/1/0068/4215/5090/files/pl_MoneyTree_6IN_po_newcer_gray_1917886e-ed95-4a6d-ac7d-d8b41797104e.png?v=1697005320';
const logoVisualizerOptionsHeight = 316;
const gutter = 100;
const potImageAspectRatio = 0.775;
const OriginalCanvasWidthDesktop = 450;
const CanvasHeightDesktop = 938;
const CanvasCssHeight = window.innerHeight - logoVisualizerOptionsHeight - gutter;
const CanvasWidthDesktop = CanvasHeightDesktop * potImageAspectRatio; // 726
const scaleFactor = CanvasWidthDesktop / OriginalCanvasWidthDesktop; // 1.61

const rustColorForNavy = '#c1a285';
const rustColorForWhite = '#c1a285';
const rustColorForGrey = '#c1a285';
const maxLogoWidth = 90 * scaleFactor;
const maxLogoHeight = 70 * scaleFactor;
const squareLogoSize = 40 * scaleFactor;
const potImageMap = {} as Record<string, HTMLImageElement>;
const ApiHost = 'https://api.livelyroot.com';
const uploadedResult: Record<string, boolean> = {};

const getEngravingDimensions = (svgLogoWidth: number, svgLogoHeight: number) => {
  const selectedPotColor = (document.querySelector('input[name="pot-color"]:checked') as HTMLInputElement).value;
  const svgAspectRatio = svgLogoWidth / svgLogoHeight;
  let engravedLogoWidth;
  let engravedLogoHeight;

  if (svgAspectRatio === 1) {
    engravedLogoWidth = squareLogoSize;
    engravedLogoHeight = squareLogoSize;
  } else {
    engravedLogoWidth = maxLogoWidth;
    engravedLogoHeight = engravedLogoWidth / svgAspectRatio;

    if (engravedLogoHeight >= maxLogoHeight) {
      engravedLogoHeight = maxLogoHeight;
      engravedLogoWidth = engravedLogoHeight * svgAspectRatio;
    }
  }

  // eslint-disable-next-line no-nested-ternary
  const imageCompensation = selectedPotColor === 'grey' ? 8 : (selectedPotColor === 'white' ? 4 : 0);
  const logoXCoordinate = (CanvasWidthDesktop - engravedLogoWidth) / 2 + imageCompensation;
  // const logoYCoordinate = (selectedPotColor === 'white' ? 0.6 : 0.65) * CanvasHeightDesktop - (engravedLogoHeight / 2);
  const logoYCoordinate = (0.83) * CanvasHeightDesktop - (engravedLogoHeight / 2);

  return [logoXCoordinate, logoYCoordinate, engravedLogoWidth, engravedLogoHeight];
};

const getLogoColorForPot = (potColor: string) => {
  switch (potColor) {
    case 'white':
      return rustColorForWhite;
    case 'grey':
      return rustColorForGrey;
    case 'navy':
      return rustColorForNavy;
    default:
      return rustColorForNavy;
  }
};

const getRustLogo = (svgElement: SVGSVGElement, potColor: string) => {
  const clonedSvgElement = svgElement.cloneNode(true) as HTMLElement;
  const allSvgElements = clonedSvgElement.querySelectorAll('*');
  const logoColor = getLogoColorForPot(potColor);

  allSvgElements.forEach((svgChildEl: HTMLElement) => {
    if (svgChildEl.style) {
      // eslint-disable-next-line no-param-reassign
      svgChildEl.style.fill = logoColor;
      // eslint-disable-next-line no-param-reassign
      svgChildEl.style.stroke = logoColor;
    }
  });

  return clonedSvgElement;
};

const drawLogoOnCanvas = (
  svgElement: SVGSVGElement, potColor: string,
): Promise<void> => new Promise((resolve) => {
  const canvasEl = document.getElementById('js-logo-visualizer-canvas') as HTMLCanvasElement;
  const ctx = canvasEl.getContext('2d');
  const rustColoredLogo = getRustLogo(svgElement, potColor);
  const { height: heightPx, width: widthPx } = getComputedStyle(svgElement);
  const svgWidth = parseInt(widthPx.split('px')[0], 10);
  const svgHeight = parseInt(heightPx.split('px')[0], 10);

  const { outerHTML } = rustColoredLogo;
  const blob = new Blob([outerHTML], { type: 'image/svg+xml;charset=utf-8' });
  const blobUrl = window.URL.createObjectURL(blob);

  const image = new Image();
  image.crossOrigin = 'anonymous';

  image.onload = () => {
    const [x, y, w, h] = getEngravingDimensions(svgWidth, svgHeight);
    ctx.drawImage(
      image, x, y, w, h,
    );

    resolve();
  };

  image.src = blobUrl;
});

const clearCanvas = () => {
  const canvasEl = document.getElementById('js-logo-visualizer-canvas') as HTMLCanvasElement;
  const ctx = canvasEl.getContext('2d');

  ctx.clearRect(0, 0, canvasEl.width, canvasEl.height);
};

const drawPot = (potColor: string) => {
  const potImage = potImageMap[potColor];
  const canvasEl = document.getElementById('js-logo-visualizer-canvas') as HTMLCanvasElement;
  const ctx = canvasEl.getContext('2d');

  if (potImage) {
    ctx.drawImage(potImage, 0, 0, canvasEl.width, canvasEl.height);
  }
};

const uploadCanvasResult = (fileName: string, potColor: string) => {
  const canvasEl = document.getElementById('js-logo-visualizer-canvas') as HTMLCanvasElement;
  const uploadKey = `${fileName}__${potColor}`;

  if (uploadedResult[uploadKey]) { return; }

  canvasEl.toBlob(async (blob) => {
    const body = new FormData();
    body.append('image', blob);
    body.append('type', 'result');
    const res = await fetch(`${ApiHost}/images/uploadfile`, {
      body,
      method: 'POST',
    });

    if (res.ok) {
      uploadedResult[uploadKey] = true;
    }
  }, 'image/png', 1);
};

const refreshPotAndLogo = async (potColor: string, fileName?: string) => {
  clearCanvas();
  drawPot(potColor);

  const svgLogo = document.querySelector('.logo-visualizer__svg-logo svg') as SVGSVGElement;
  if (svgLogo) {
    await drawLogoOnCanvas(svgLogo, potColor);

    if (fileName) {
      uploadCanvasResult(fileName, potColor);
    }
  }
};

const containsRasterImage = (svgContent: string) => {
  const svgEl = document.createElement('svg');
  svgEl.innerHTML = svgContent;

  return !!svgEl.querySelector('image');
};

const fetchRemoteSvg = async (logoUrl: string) => {
  const res = await fetch(`${ApiHost}/images/process`, {
    body: JSON.stringify({ fileUrl: logoUrl }),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });

  if (!res.ok) {
    return null;
  }

  const svgLogo = await res.text();
  return svgLogo;
};

const parseLocalSvgLogo = async (logo: File):Promise<string> => new Promise((resolve) => {
  const reader = new FileReader();
  reader.onload = (event) => {
    if (containsRasterImage(event.target.result as string)) {
      resolve(null);
    }

    resolve(event.target.result as string);
  };

  reader.readAsText(logo, 'UTF-8');
});

const uploadLogo = async (logo: File) => {
  const body = new FormData();
  body.append('image', logo);
  body.append('type', 'logo');

  return fetch(`${ApiHost}/images/uploadfile`, {
    body,
    method: 'POST',
  });
};

const displayError = (error: 'processing_error' | 'bad_request' | 'raster_svg' | 'missing_file') => {
  const form = document.querySelector('.js-logo-form');
  const errorDiv = form.querySelector('.error');
  let errorMessage = '';

  if (error === 'bad_request') {
    errorMessage = 'We only support SVG, PNG, JPEG, AI & EPS formats';
  } else if (error === 'processing_error') {
    errorMessage = 'Something went wrong while processing your logo';
  } else if (error === 'raster_svg') {
    errorMessage = 'Unfortunately we do not support Raster SVGs at the moment, please try with a true vector SVG image or any other listed image formats';
  } else {
    errorMessage = 'Please choose a logo to process';
  }

  errorDiv.innerHTML = errorMessage;
  errorDiv.classList.remove('hidden');
};

const onLogoFileSubmit = async (e: InputEvent) => {
  e.preventDefault();
  e.stopPropagation();

  const form = e.target as HTMLFormElement;
  const errorDiv = form.querySelector('.error');
  const fileInput = form.querySelector('#logo') as HTMLInputElement;
  const overlay = document.querySelector('.js-logo-visualizer .logo-visualizer-overlay') as HTMLElement;
  const { files: [logo] } = fileInput;
  let svgLogo:string = null;

  errorDiv.classList.add('hidden');

  if (!logo) {
    displayError('missing_file');
    return;
  }

  overlay.classList.remove('hidden');

  const res = await uploadLogo(logo);
  if (!res.ok) {
    displayError('processing_error');
    overlay.classList.add('hidden');
    return;
  }

  const { url: logoUrl } = await res.json();

  if (!logoUrl) {
    displayError('processing_error');
    overlay.classList.add('hidden');
    return;
  }

  if (logo.type !== 'image/svg+xml') {
    svgLogo = await fetchRemoteSvg(logoUrl);

    if (!svgLogo) {
      displayError('processing_error');
      overlay.classList.add('hidden');
      return;
    }
  } else {
    svgLogo = await parseLocalSvgLogo(logo);

    if (svgLogo === null) {
      svgLogo = await fetchRemoteSvg(logoUrl);

      if (!svgLogo) {
        displayError('raster_svg');
        overlay.classList.add('hidden');
        return;
      }
    }
  }

  const svgLogoContainer: HTMLElement = document.querySelector('.logo-visualizer__svg-logo');
  svgLogoContainer.innerHTML = svgLogo;

  const selectedPotColor = (document.querySelector('input[name="pot-color"]:checked') as HTMLInputElement).value;
  refreshPotAndLogo(selectedPotColor, logo.name);
  overlay.classList.add('hidden');
};

const getColorLabel = (color: string) => {
  if (color === 'white') {
    return 'Matte White';
  }

  if (color === 'grey') {
    return 'Matte Grey';
  }

  if (color === 'navy') {
    return 'Matte Navy';
  }

  return '';
};

const onChangePot = (e: InputEvent) => {
  const { target } = e;
  const color = (target as HTMLInputElement).value;
  const selectedColorEl: HTMLElement = document.querySelector('.js-selected-pot-color');
  const form = document.querySelector('.js-logo-form');
  const fileInput = form.querySelector('#logo') as HTMLInputElement;
  const fileName = fileInput.files[0]?.name || '';

  selectedColorEl.innerText = getColorLabel(color);

  refreshPotAndLogo(color, fileName);
};

const loadAllPotImages = async (images: string[]) => {
  const allPotImages = await Promise.all(
    images.map(((image) => new Promise<HTMLImageElement>((resolve) => {
      const potImage = new Image();
      potImage.crossOrigin = 'anonymous';

      potImage.onload = () => {
        resolve(potImage);
      };

      potImage.src = image;
    }))),
  );

  return allPotImages;
};

const resizeCanvas = () => {
  const canvasEl = document.getElementById('js-logo-visualizer-canvas') as HTMLCanvasElement;
  canvasEl.width = CanvasWidthDesktop;
  canvasEl.height = CanvasHeightDesktop;
  canvasEl.style.height = `${CanvasCssHeight}px`;
};

const init = async () => {
  const svgLogoContainer = document.createElement('div');
  svgLogoContainer.classList.add('logo-visualizer__svg-logo');
  document.body.appendChild(svgLogoContainer);

  const logoForm = document.querySelector('.js-logo-form');

  logoForm.addEventListener('submit', onLogoFileSubmit);

  const potColorInputCtr = document.querySelector('.logo-visualizer__pot-colors');
  potColorInputCtr.addEventListener('change', onChangePot);

  resizeCanvas();
  const [white, grey, navy] = await loadAllPotImages(
    [whitePotImageSrc, greyPotImageSrc, navyPotImageSrc],
  );

  potImageMap.white = white;
  potImageMap.grey = grey;
  potImageMap.navy = navy;

  drawPot('white');
};

init();

export {};
